module.exports = __webpack_public_path__ + "static/media/serieNaRealIniciativa.84e1edf2.jpg";